import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconPlay({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `edu-icon edu-icon--${size} ${className}`;
  return <>{!!srText && <span className='sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="m15.5 10-11 6.5v-13z" /></svg></>;
}
export default IconPlay;